import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FateDropdown } from 'fate-editor';

/**Componente per la dropdown delle citazioni da Talmud Yerushalmi */
@Component({
  selector: 'app-talmud-yerushalmi-dropdown',
  templateUrl: '../quote-template.html',
  styleUrls: ['../editor-dropdowns.css']
})
export class TalmudYerushalmiDropdownComponent implements FateDropdown {
  /**Input, la stringa eventualmente selezionata */
  @Input()
  public value: string;
  /**Emettitore per il valore selezionato dalla dropdown */
  @Output() public valueChange = new EventEmitter<string>();

  /**Lista delle citazioni possibili da Talmud Yerushalmi */
  noteList = [
    {
      etichetta: '‘Avodà Zarà',
      valore: 'TY, <i>‘Avodà Zarà</i>'
    },
    {
      etichetta: '‘Eruvìn',
      valore: 'TY, <i>‘Eruvìn</i>'
    },
    {
      etichetta: '‘Orlà',
      valore: 'TY, <i>‘Orlà</i>'
    },
    {
      etichetta: 'Bavà Batrà',
      valore: 'TY, <i>Bavà Batrà</i>'
    },
    {
      etichetta: 'Bavà Metzi‘à',
      valore: 'TY, <i>Bavà Metzi‘à</i>'
    },
    {
      etichetta: 'Bavà Qammà',
      valore: 'TY, <i>Bavà Qammà</i>'
    },
    {
      etichetta: 'Berakhòt',
      valore: 'TY, <i>Berakhòt</i>'
    },
    {
      etichetta: 'Betzà',
      valore: 'TY, <i>Betzà</i>'
    },
    {
      etichetta: 'Bikkurìm',
      valore: 'TY, <i>Bikkurìm</i>'
    },
    {
      etichetta: 'Chaghigà',
      valore: 'TY, <i>Chaghigà</i>'
    },
    {
      etichetta: 'Challà',
      valore: 'TY, <i>Challà</i>'
    },
    {
      etichetta: 'Demài',
      valore: 'TY, <i>Demài</i>'
    },
    {
      etichetta: 'Ghittìn',
      valore: 'TY, <i>Ghittìn</i>'
    },
    {
      etichetta: 'Horayòt',
      valore: 'TY, <i>Horayòt</i>'
    },
    {
      etichetta: 'Ketubbòt',
      valore: 'TY, <i>Ketubbòt</i>'
    },
    {
      etichetta: 'Kilàim',
      valore: 'TY, <i>Kilàim</i>'
    },
    {
      etichetta: 'Ma‘asèr Shenì',
      valore: 'TY, <i>Ma‘asèr Shenì</i>'
    },
    {
      etichetta: 'Ma‘asròt',
      valore: 'TY, <i>Ma‘asròt</i>'
    },
    {
      etichetta: 'Makkòt',
      valore: 'TY, <i>Makkòt</i>'
    },
    {
      etichetta: 'Meghillà',
      valore: 'TY, <i>Meghillà</i>'
    },
    {
      etichetta: 'Mo‘èd Qatàn',
      valore: 'TY, <i>Mo‘èd Qatàn</i>'
    },
    {
      etichetta: 'Nazìr',
      valore: 'TY, <i>Nazìr</i>'
    },
    {
      etichetta: 'Nedarìm',
      valore: 'TY, <i>Nedarìm</i>'
    },
    {
      etichetta: 'Niddà',
      valore: 'TY, <i>Niddà</i>'
    },
    {
      etichetta: 'Peà',
      valore: 'TY, <i>Peà</i>'
    },
    {
      etichetta: 'Pesachìm',
      valore: 'TY, <i>Pesachìm</i>'
    },
    {
      etichetta: 'Qiddushìn',
      valore: 'TY, <i>Qiddushìn</i>'
    },
    {
      etichetta: 'Rosh haShanà',
      valore: 'TY, <i>Rosh haShanà</i>'
    },
    {
      etichetta: 'Sanhedrìn',
      valore: 'TY, <i>Sanhedrìn</i>'
    },
    {
      etichetta: 'Shabbàt',
      valore: 'TY, <i>Shabbàt</i>'
    },
    {
      etichetta: 'Sheqalìm',
      valore: 'TY, <i>Sheqalìm</i>'
    },
    {
      etichetta: 'Shevi‘ìt',
      valore: 'TY, <i>Shevi‘ìt</i>'
    },
    {
      etichetta: 'Shevu‘òt',
      valore: 'TY, <i>Shevu‘òt</i>'
    },
    {
      etichetta: 'Sotà',
      valore: 'TY, <i>Sotà</i>'
    },
    {
      etichetta: 'Sukkà',
      valore: 'TY, <i>Sukkà</i>'
    },
    {
      etichetta: 'Ta‘anìt',
      valore: 'TY, <i>Ta‘anìt</i>'
    },
    {
      etichetta: 'Terumòt',
      valore: 'TY, <i>Terumòt</i>'
    },
    {
      etichetta: 'Yevamòt',
      valore: 'TY, <i>Yevamòt</i>'
    },
    {
      etichetta: 'Yomà',
      valore: 'TY, <i>Yomà</i>'
    }
  ]; 

  /**Indice elemento selezionato */
  public selected = 0;

  /**
   * Metodo che gestisce l'emissione del valore selezionato
   * @param value {any} il valore selezionato
   */
  public changeValue(value) {
    this.valueChange.emit(value);
  }

  /**Metodo che gestisce la selezione del successivo */
  public selectNext() {
    this.selected++;
    if (this.selected >= this.noteList.length) {
      this.selected = this.noteList.length - 1;
    }
  };
  /**Metodo che gestisce la selezione del precedente */
  public selecPrevious() {
    this.selected--;
    if (this.selected < 0) {
      this.selected = 0;
    }
  };
  /**Metodo che conferma la selezione lanciando il metodo di cambio valore */
  public confirmSelection() {
    this.changeValue(this.noteList[this.selected]);
  };
  constructor() { }

}
